<template>
    <x-select
        v-model="submission.entity_id"
        :items="formattedEntities"
        class="required"
        label="Choose entity"
        placeholder="Entity"
        item-value="id"
        item-text="name"
        :rules="[
            v => ruleRequired(v, 'Entity')
        ]"
        append-icon="keyboard_arrow_down"
        outline
        :disabled="!isEntityActive"
        :hint="!isEntityActive ? 'Facility/Entity is inactive, contact admin broker' : null"
        :persistent-hint="!isEntityActive"
    />
</template>


<script>
import rules from '~/mixins/rules';

export default {
    name: "EntityField",
    props: ["submission", "entities"],
    mixins: [rules],
    computed: {
        formattedEntities() {
            if (!this.isEntityActive) {
                return [
                    {
                        id: this.submission.entity?.id || null,
                        name: this.submission.entity?.name || "No entity"
                    }
                ];
            }

            return this.entities;
        },
        isEntityActive() {
            return this.isDeclaration ? (this.isFacilityActive && (this.submission.entity === null || this.submission.entity?.status === 1)) : true;
        },
        isFacilityActive() {
            return  this.submission.facility?.status === 1;
        },
        isDeclaration() {
            return this.submission.risk_type === "declaration";
        },
    },
    watch: {
        entities: {
            handler() {
                if (!this.isDeclaration) {
                    const self = this;
                    this.submission.entity_id = this.entities.filter(function (e) {
                        return e.id === self.submission.entity_id;
                    }).length
                        ? this.submission.entity_id
                        : null;
                }
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
:deep() {
    .x-messages__message {
        color: $color-red !important;
    }
}
</style>
